import { useFlag } from '@fhs-legacy/frontend/src/utils/launchdarkly';

export function useIsPersonalizedHomepageEnabled(): boolean {
  return useFlag('enable-personalized-loyalty-homepage');
}
